import TekoID, {
  InitOptions as IAMInitOptions,
  IUserManager,
} from "teko-oauth2";

type InitOptions = IAMInitOptions & {
  appId: string;
  loginUri: string;
  clientId?: string;
};

export const instance: {
  appId: string;
  loginUri: string;
  user: IUserManager;
  tekoIamVersion: string;
  init: (configs: InitOptions) => Promise<void>;
  login: (redirectUri?: string) => void;
} = {
  appId: "",
  loginUri: "",
  user: {} as IUserManager,
  tekoIamVersion: TekoID.version,
  init: async (configs: InitOptions) => {
    const { appId, clientId, loginUri, ...restConfigs } = configs;
    instance.appId = appId;
    instance.loginUri = loginUri;

    if (!!clientId) {
      try {
        await TekoID.init({ clientId, ...restConfigs });
        console.log("Init successfully");
        instance.user = TekoID.user;
      } catch (err) {
        console.warn(err);
      } finally {
        Promise.resolve();
      }
    }
  },
  login: (redirectUri) => {
    const { loginUri, appId } = instance;
    let target = `${loginUri}/app/${appId}`;
    if (!!redirectUri) {
      target = `${target}?redirectTo=${redirectUri}`;
    }
    window.location.href = target;
  },
};
